// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"651":"dd409d6aa8844980","741":"f276f5017855a4d5"}[chunkId] + ".js";
};